import React, { useEffect, useRef, useState } from 'react';
import MaterialTable from '@material-table/core';
import { Button } from 'react-bootstrap';
import { FiletypePdf } from 'react-bootstrap-icons';
import './MessageList.css';

const MessageList = ({filters, messages, getMessages, clearMessages, hideMessages, viewMessage, downloadMessages}) => {
  const isMountedRef = useRef(null);
  const [tableLoading, setTableLoading] = useState(true);
  const [refreshKey, setRefreshKey] = useState(0);

  useEffect(() => {
    setRefreshKey((prevKey) => prevKey + 1);
  }, [filters]);

  const handleRefresh = () => {
    setRefreshKey((prevKey) => prevKey + 1);
  };

  const handleHideMessages = (evt, data) =>{

    let msgIds = data.map((sub) => {
      return {
        id: sub.messageId,
        timestamp: sub.messageTimestamp,
      }
    });
    let msgData = {
      'preferences':{
        'hidden': msgIds
      }
    };

    hideMessages(msgData)
    .then(() => {
      handleRefresh();
    })
    .catch((error) => {
      console.error("Error hiding messages:", error);
    });
  };

  const handleDownloadMessages = (evt, data) => {
    let msgIds = data.map((sub) => {
      return sub.messageId
    });
    console.log(msgIds);
    downloadMessages(msgIds);
  };

  const handleViewMessage = (messageId)=>{
    viewMessage(messageId);
  };

  const toSnakeCase = (str) => {
    return str.replace(/([a-z])([A-Z])/g, '$1_$2').toLowerCase();
  };

  const myData = messages.map((sub) => {
    return {
      messageId: sub.messageId,
      patientFirstName: sub.patientFirstName,
      patientLastName: sub.patientLastName,
      patientDob: sub.patientDob,
      messageType: sub.messageType,
      sourceOrgName: sub.sourceOrgName,
      messageTimestamp:sub.messageTimestamp,
      messageTimestampDisp: sub.messageTimestamp.split("T").join(" ").split(".")[0],
      orderingProvider: sub.orderingProvider,
      view: (
        <Button onClick={() => handleViewMessage(sub.messageId)} variant="link">
            <FiletypePdf className="material-icons icon mr-1" />
          </Button>
      ),
    };
  });

  return (
    <>
      <div>
        <MaterialTable
          className='custom-message-list'
          key={refreshKey}
          columns={[
            { title: 'First Name', field: 'patientFirstName' },
            { title: 'Last Name', field: 'patientLastName' },
            { title: 'Patient DOB', field: 'patientDob' },
            { title: 'Message Type', field: 'messageType' },
            { title: 'Source Org', field: 'sourceOrgName' },
            { title: 'Date Received', field: 'messageTimestampDisp',defaultSort: 'desc'},
            { title: 'Ordering Prov.', field: 'orderingProvider' },
            { title: 'Display PDF', field: 'view', sorting: false },
          ]}
          data={(query) =>
            new Promise((resolve, reject) => {
              let msg_params = {
                ...filters,
                page: query.page,
                limit: query.pageSize,
              };
              if (query.orderBy !== undefined && query.orderDirection !== undefined) {
                if (query.orderBy.field === 'messageTimestampDisp') {
                  msg_params.sort_by = 'message_timestamp';
                } else if (query.orderBy.field === 'orderingProvider') {
                  msg_params.sort_by = 'ordering_provider_name';
                } else if (query.orderBy.field === 'sourceOrgName') {
                  msg_params.sort_by = 'managing_org_name';
                } else {
                  msg_params.sort_by = toSnakeCase(query.orderBy.field);
                }
                msg_params.sort_order = query.orderDirection;
              }

              getMessages(msg_params)
                .then((result) => {
                  resolve({
                    data: result.data.map((sub) => {
                      return {
                        messageId: sub.messageId,
                        patientFirstName: sub.patientFirstName,
                        patientLastName: sub.patientLastName,
                        patientDob: sub.patientDob,
                        messageType: sub.messageType,
                        sourceOrgName: sub.sourceOrgName,
                        messageTimestamp:sub.messageTimestamp,
                        messageTimestampDisp: sub.messageTimestamp.split("T").join(" ").split(".")[0],
                        orderingProvider: sub.orderingProvider,
                        view: (
                          <Button onClick={() => handleViewMessage(sub.messageId)} variant="link">
                              <FiletypePdf className="material-icons icon mr-1" />
                            </Button>
                        ),
                      };
                    }), // The data to display in the table
                    page: query.page, // The current page
                    totalCount: result.pagination.totalCount, // The total number of rows
                  });
                })
                .catch((error) => {
                  console.error('Error fetching paginated data:', error);
                  reject(error);
                });
            })
          }
          options={{
            headerStyle: {
              backgroundColor: '#223c89',
              color: '#FFFFFF',
              zIndex: 0,
            },
            emptyRowsWhenPaging: false,
            tableLayout: 'auto',
            pageSize: 10,
            pageSizeOptions: [10],
            selection: true,
            actionsColumnIndex: -1,
            paginationType: 'stepped',
            remote:true,
            search:false,
          }}
          onChangePage={(newPage) => getMessages({page:newPage})}
          title=""
          localization={{
            body: {
              emptyDataSourceMessage:
                myData.length > 0
                  ? 'Loading messages...'
                  : 'There are no messages to show.',
            },
          }}
          actions={[
            {
              tooltip: 'Hide Selected Messages',
              icon: 'close',
              onClick: (evt, data) => { handleHideMessages(evt, data); }
            },
            {
              tooltip: 'Download Selected Messages',
              icon: 'download',
              onClick: (evt, data) => { handleDownloadMessages(evt, data); }
            }
          ]}
        />
      </div>
    </>
  );
};

export default MessageList;
